import { Box, IconButton } from '@mui/material';
import DOMPurify from 'dompurify';
import { useStyles } from './styles';
import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';

function AxlSupport({ title, phone, email }) {
  const classes = useStyles();

  const hrefTo = (href) => {
    if (href === null || href === '') return;
    window.location.href = href;
  };

  const isHide = !(phone || email);

  return isHide ? null : (
    <Box my={3}>
      <Box dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} mb={2} sx={classes.title} />
      <Box display="flex" gap={1} flexWrap={'wrap'} justifyContent="center">
        {phone && (
          <IconButton onClick={() => hrefTo(phone)} sx={classes.iconButton} color="primary" size="large">
            <PhoneIcon sx={classes.icon} color="primary" />
            <Box component="span" sx={classes.text}>
              Phone Support
            </Box>
          </IconButton>
        )}
        {email && (
          <IconButton onClick={() => hrefTo(email)} sx={classes.iconButton} color="primary" size="large">
            <EmailIcon sx={classes.icon} color="primary" />
            <Box component="span" sx={classes.text}>
              Email Support
            </Box>
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

export default AxlSupport;
